import { createSlice } from '@reduxjs/toolkit';
import { IIndustryPercentage } from '../../../forms-v2/components/dynamic-fields/pi_industry_percentage/IIndustryPercentage';
import { IndustryPercentageReducer } from '../../reducers/IndustryPercentageReducer';

const initialState: IIndustryPercentage = {
	list: [],
	isStart: true,
};

export const industriesPercentageSlice = createSlice({
	name: 'industry-percentage',
	initialState,
	reducers: IndustryPercentageReducer,
});

export const { mergeListIndustries, resetListIndustries } = industriesPercentageSlice.actions;

export default industriesPercentageSlice.reducer;
